import React, { useEffect } from "react";
import { HeroB } from "../components/home-b/HeroB";
import { TrustedBy } from "../components/home-a/TrustedBy";
import { Services } from "../components/home-a/Services";
import { Stats } from "../components/home-a/Stats";
import { DNSPreview } from "../components/home-a/DNSPreview";
import { Testimonials } from "../components/home-a/Testimonials";
import { Pricing } from "../components/home-a/Pricing";
import { FAQ } from "../components/home-a/FAQ";
import { CTABand } from "../components/home-a/CTABand";
import { toast } from "sonner";

export default function HomeB({ onAddToCart }) {
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            setTimeout(() => {
                document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 100);
        }
    }, []);

    const handleAdd = (domain) => {
        onAddToCart?.(domain);
        toast.success(`Added ${domain.domain} to cart`);
    };

    return (
        <main data-testid="home-b-page" className="bg-limestone-100">
            <HeroB onAddToCart={handleAdd} />
            <TrustedBy />
            <Services />
            <DNSPreview />
            <Stats />
            <Testimonials />
            <Pricing />
            <FAQ />
            <CTABand />
        </main>
    );
}
